/* eslint-disable no-restricted-globals */
import { useMemo } from 'react';

import { US_STATES } from '../../../constants/formOptions';
import useForm from '../../utils/useForm';
import { useFormStore } from '../../../store';
import useTinType from '../../utils/useTinType';

const useLenderOnboardingStepOne = (onSubmit, values, formId) => {
  const { tinTypeOptions, tinInputMask } = useFormStore();

  const fields = useMemo(
    () => [
      {
        title: 'Lender',
        fields: [
          {
            title: 'Entity Type',
            name: 'notused',
            type: 'radio',
            options: [
              { label: 'Individual', value: 'Individual' },
              { label: 'Entity', value: 'Entity' },
            ],
            defaultValue: 'Individual',
            required: true,
          },
          {
            title: 'Lender Name',
            name: 'name',
            type: 'text',
            required: true,
          },
          {
            title: 'TIN Type',
            name: 'TIN_type',
            type: 'radio',
            options: tinTypeOptions[formId] || [],
            required: true,
          },
          {
            title: 'TIN',
            name: 'TIN',
            type: 'text',
            mask: tinInputMask[formId],
            validation: 'tin',
            required: true,
          },
        ],
      },
      {
        title: 'Mailing Address',
        fields: [
          {
            title: 'Address Line 1',
            name: 'address_line_1',
            type: 'text',
            required: true,
          },
          {
            title: 'Address Line 2',
            name: 'address_line_2',
            type: 'text',
          },
          {
            title: 'City',
            name: 'city',
            type: 'text',
            required: true,
          },
          {
            title: 'State',
            name: 'state',
            type: 'select',
            options: US_STATES,
            required: true,
          },
          {
            title: 'ZIP',
            name: 'zip',
            type: 'text',
            validation: 'zip',
            required: true,
          },
        ],
      },
    ],
    [formId, tinInputMask, tinTypeOptions]
  );

  const { formik } = useForm({
    fields,
    onSubmit,
    values,
    onlyValuesPresentInForm: true,
  });

  useTinType({
    formik,
    tinTypeFieldName: 'TIN_type',
    entityNameFieldName: 'notused',
    formId,
    values,
  });

  return { formik, fields };
};

export default useLenderOnboardingStepOne;
